<template>
  <div class="container-cap" id="tools-evolution">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          Évolution des caractéristiques
          <span v-if="target">
            <br>
            <span :class="`label label-${target.style}`">
              {{ target.name }}</span>
          </span>
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div v-if="target == null">
          <sui-module-selector :targets="targets"
             @selected="selectModule">
          </sui-module-selector>
        </div>

        <div v-else-if="!datasetsLoaded && datasetListLoaded">
          <sui-dataset-selector :locked="datasetsLocked"
             :availableDatasetsByYear="dsetByYear"
             @selected="downloadSheets">
          </sui-dataset-selector>
        </div>

        <div v-if="datasetsLoaded">
          <sui-evolution-sheet-caracteristics :data="evolutionData" :prefix="target.prefix">
          </sui-evolution-sheet-caracteristics>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import promise from '@/sui/tools/promise'
import evolution from '@/sui/sc/evolution'

import suiModuleSelector from '@/sui/components/module/selector'
import suiDatasetSelector from '@/sui/components/dataset/selector'
import suiEvolutionSheetCaracteristics from '@/sui/components/evolution/sheetCaracteristics'

import datasetNames from '@/mixins/datasetNames'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'tools-caracteristics-evolution',

  mixins: [ datasetNames ],

  data: function () {
    return {
      focus: {
        text: '',
        model: null,
        showList: false
      },
      filter: '',
      targets: evolution.targets,
      target: null,
      current: null,
      computing: false,
      datasetsLocked: false,
      filteredSheetLists: null,
      referenceSheetLists: null,
      datasetsLoaded: null,
      appliedFilter: null,
      caracFilter: null,
      removeDoubles: false
    }
  },

  mounted: function () {
    this.fillDatasetNames(false)
  },

  methods: {
    selectModule: function (m) {
      this.target = m
    },

    downloadSheets: function (current) {
      this.datasetsLocked = true
      const { promises, names } = evolution.buildPromises(
        this.$store,
        this.target,
        current,
        true
      )
      this.current = current

      const vm = this
      promise.awaitAll(
        promises,
        () => {
          vm.datasetsLoaded = names
          vm.datasetsLocked = true
        },
        (e) => {
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            html: true,
            content: `Une erreur est survenue lors du téléchargement
des fiches : <ul><li>${e.join('</li><li>')}</li></ul>`,
            duration: 0
          })
          vm.datasetsLocked = false
        }
      )
    }
  },

  computed: {
    ...mapGetters({
      getListByName: 'surveillances/listByName',
      getSheets: 'dataset/getSheets'
    }),

    ...mapState({
      infections: state => state.infections.all
    }),

    dsetByYear: function () {
      if (this.target == null) {
        return null
      }

      return this.target.observation
        ? this.availableDatasetsByYear.obs
        : this.availableDatasetsByYear.surv
    },

    sheetLists: function () {
      if (this.target == null || this.datasetsLoaded == null) {
        return null
      }
      const result = []

      for (let y in this.datasetsLoaded) {
        const dset = this.datasetsLoaded[y]
        const sl = this.target.sheetList(this, y, dset)
        if (sl == null) {
          return null
        }

        result.push(
          {
            year: y,
            dset: dset,
            dist: this.target.distribution,
            vars: this.target.variables(y),
            list: sl
          }
        )
      }

      return result
    },

    missingDataset: function () {
      for (let y in this.current) {
        if (this.current[y] == null) {
          return true
        }
      }
      return false
    },

    tables: function () {
      if (this.target == null) {
        return null
      }

      const result = {}
      for (let y in this.datasetsLoaded) {
        result[y] = this.target.tables(y)
      }
      return result
    },

    evolutionData: function () {
      return {
        tables: this.tables,
        sheets: this.sheetLists,
        surveillanceField: this.target.surveillanceField,
        doubles: this.target.doubles,
        datasets: this.datasetsLoaded
      }
    }
  },

  components: {
    'sui-evolution-sheet-caracteristics': suiEvolutionSheetCaracteristics,
    'sui-module-selector': suiModuleSelector,
    'sui-dataset-selector': suiDatasetSelector
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#tools-caracteristics-evolution {
  min-height: 100rem;
}

.compute-button {
  margin-bottom: 1rem;
}

.carac-input {
  width: 100%
}

.sheets, .doubles {
  margin-top: 1rem;
}

.focus-list-title {
  font-weight: bold;
  font-size: 120%;
}

.focus-list-subtitle {
  font-style: italic;
  font-size: 110%;
  text-indent: 2rem;
}

.focus-list-value {
  text-indent: 4rem;
}

.btn-toolbar > .c-checkbox {
  margin-left: 5px;
}
</style>
